module.exports = __webpack_public_path__ + "img/Review_text02b_morebetter.76bd1a98.png";